<template>
    <default-template>
        <v-container>
            <slot />
        </v-container>
    </default-template>
</template>
<script>
import DefaultTemplate from "../DefaultTemplate.vue";
export default {
    components: {
        DefaultTemplate
    }
}
</script>